module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "candidateForm",
    attrs: {
      "model": _vm.site,
      "rules": _vm.rules,
      "label-position": "top",
      "inline": ""
    }
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Site Name: "), _c('span', {
    class: _vm.titleClass(_vm.site.status)
  }, [_vm._v(_vm._s(_vm.site.siteName ? _vm.site.siteName : 'not entered'))])])])], 1), _vm._v(" "), (!_vm.candidate.client_id) ? _c('select-sharer', {
    model: {
      value: (_vm.candidate.client_id),
      callback: function($$v) {
        _vm.$set(_vm.candidate, "client_id", $$v)
      },
      expression: "candidate.client_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Site Name",
      "prop": "siteName",
      "required": "",
      "placeholder": "Site Name"
    },
    model: {
      value: (_vm.site.siteName),
      callback: function($$v) {
        _vm.$set(_vm.site, "siteName", $$v)
      },
      expression: "site.siteName"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Site ID",
      "prop": "siteId",
      "required": "",
      "placeholder": "Your Site ID",
      "max-length": 16
    },
    model: {
      value: (_vm.site.siteId),
      callback: function($$v) {
        _vm.$set(_vm.site, "siteId", $$v)
      },
      expression: "site.siteId"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Your Ref",
      "placeholder": "Your Ref",
      "max-length": 16
    },
    model: {
      value: (_vm.candidate.clientRef),
      callback: function($$v) {
        _vm.$set(_vm.candidate, "clientRef", $$v)
      },
      expression: "candidate.clientRef"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Title",
      "placeholder": "Title",
      "max-length": 88
    },
    model: {
      value: (_vm.candidate.title),
      callback: function($$v) {
        _vm.$set(_vm.candidate, "title", $$v)
      },
      expression: "candidate.title"
    }
  }), _vm._v(" "), _c('select-coverage', {
    attrs: {
      "label": "Station Type"
    },
    model: {
      value: (_vm.candidate.stationType),
      callback: function($$v) {
        _vm.$set(_vm.candidate, "stationType", $$v)
      },
      expression: "candidate.stationType"
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('select-structure', {
    attrs: {
      "label": "Structure Type"
    },
    model: {
      value: (_vm.struct.structure_id),
      callback: function($$v) {
        _vm.$set(_vm.struct, "structure_id", $$v)
      },
      expression: "struct.structure_id"
    }
  }), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Structure Height",
      "min": 1,
      "max": 121,
      "suffix": "m."
    },
    model: {
      value: (_vm.struct.height),
      callback: function($$v) {
        _vm.$set(_vm.struct, "height", $$v)
      },
      expression: "struct.height"
    }
  }), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Antenna AGL",
      "min": 1,
      "max": 121,
      "suffix": "m.",
      "placeholder": "Height above ground in metres"
    },
    model: {
      value: (_vm.candidate.antennaHeight),
      callback: function($$v) {
        _vm.$set(_vm.candidate, "antennaHeight", $$v)
      },
      expression: "candidate.antennaHeight"
    }
  }), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Site Width",
      "suffix": "m.",
      "placeholder": "width in metres"
    },
    model: {
      value: (_vm.struct.width),
      callback: function($$v) {
        _vm.$set(_vm.struct, "width", $$v)
      },
      expression: "struct.width"
    }
  }), _vm._v(" "), _c('integer-input', {
    attrs: {
      "label": "Site Depth",
      "suffix": "m.",
      "placeholder": "depth in metres"
    },
    model: {
      value: (_vm.struct.depth),
      callback: function($$v) {
        _vm.$set(_vm.struct, "depth", $$v)
      },
      expression: "struct.depth"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.guts
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('select-locality', {
    attrs: {
      "label": ""
    },
    model: {
      value: (_vm.loc),
      callback: function($$v) {
        _vm.loc = $$v
      },
      expression: "loc"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [(!_vm.movePos) ? _c('float-input', {
    attrs: {
      "type": "number",
      "decimals": 12,
      "placeholder": "Latitude",
      "prefix": "Lat",
      "suffix": "&deg;"
    },
    model: {
      value: (_vm.site.latitude),
      callback: function($$v) {
        _vm.$set(_vm.site, "latitude", $$v)
      },
      expression: "site.latitude"
    }
  }) : _c('span', [_vm._v("Latitude: "), _c('b', [_vm._v(_vm._s(_vm.site.latitude))]), _vm._v("°")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [(!_vm.movePos) ? _c('float-input', {
    attrs: {
      "decimals": 12,
      "type": "number",
      "placeholder": "Longitude",
      "prefix": "Lng",
      "suffix": "&deg;"
    },
    model: {
      value: (_vm.site.longitude),
      callback: function($$v) {
        _vm.$set(_vm.site, "longitude", $$v)
      },
      expression: "site.longitude"
    }
  }) : _c('span', [_vm._v("Longitude: "), _c('b', [_vm._v(_vm._s(_vm.site.longitude))]), _vm._v("°")])], 1)], 1), _vm._v(" "), (this.site.latitude && this.site.longitude) ? _c('google-map', {
    attrs: {
      "lat": this.site.latitude,
      "lng": this.site.longitude,
      "draggable": "",
      "zoom": 14,
      "width": "100%",
      "height": "41.7vh"
    },
    on: {
      "update": _vm.updateMap
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-294203e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/acquire/AcquireRequest.vue
// module id = 1466
// module chunks = 0